module.exports = __webpack_public_path__ + "media/4x3/aw-47ea7038.svg";